const SortSvg = ({sortColumn, sortOrder, currentColumn}) => {
    // If this column is the currently sorted column, show up/down arrow
    // Otherwise show expand icon
    const isActive = sortColumn === currentColumn;
    
    let iconClass = "expand"; // default
    if (isActive) {
        iconClass = sortOrder === "asc" ? "up" : "down";
    }
    
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className={`bi bi-chevron-${iconClass}`}
            viewBox="0 0 16 16"
        >
            <path
                fillRule="evenodd"
                d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
            />
        </svg>
    )
}

export default SortSvg;